module.exports = __webpack_public_path__ + "static/img/05942709.2a83c366.png";